import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";

class BritishColumbiaObstetricalFileOtherDuringPregnancySubSection extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private substanceUseOtherDuringPregnancy = "Section9_substanceUseOtherDuringPregnancy";

    public render(): JSX.Element {
        const model = this.props.form.Section9.Other;

        return (
            <div>
                <div className="inline-selection-justify-between flex-col-gap-xs">
                    <span className="bold">{this.getString("ObstetricalFile_OthersDuringPregnancyLabel")}</span>
                    <span className="margin-sm-left">
                        {this.controlRenderer.renderInlineYesNoRadio(
                            model.HasOtherDuringPregnancy,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section9.Other.HasOtherDuringPregnancy = value),
                            "Section9_OthersDuringPregnancy",
                            "radios-one-label",
                            null,
                            true
                        )}
                    </span>
                    {this.getLabelSuffix(this.getString("ObstetricalFile_CheckAllApplyingLabel"), "extra-info-label")}
                </div>
                <div className="inline-selection-justify-between padding-sm-top">
                    <div className="width-100 flex-start-align-self">
                        {this.controlRenderer.renderCheckbox(
                            "CocaineLabel",
                            model.HasCocaine,
                            value => this.mutateOtherDuringPregnancyModel(s => s.Section9.Other.HasCocaine = value, true)
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "IntravenousAbbrevDrugsLabel",
                            model.HasIntravenousDrugs,
                            value => this.mutateOtherDuringPregnancyModel(s => s.Section9.Other.HasIntravenousDrugs = value, true)
                        )}
                    </div>
                    <div className="width-100 flex-start-align-self">
                        {this.controlRenderer.renderCheckbox(
                            "OpioidsLabel",
                            model.HasOpioids,
                            value => this.mutateOtherDuringPregnancyModel(s => s.Section9.Other.HasOpioids = value, true),
                            "margin-md-left"
                        )}
                        {this.controlRenderer.renderCheckbox(
                            "PrescriptionDrugsLabel",
                            model.HasPrescriptionDrugs,
                            value => this.mutateOtherDuringPregnancyModel(s => s.Section9.Other.HasPrescriptionDrugs = value, true),
                            "margin-md-left"
                        )}
                    </div>
                    <div className="width-100 flex-start-align-self">
                        {this.controlRenderer.renderCheckbox(
                            "MethamphetaminesLabel",
                            model.HasMethamphetamines,
                            value => this.mutateOtherDuringPregnancyModel(s => s.Section9.Other.HasMethamphetamines = value, true),
                            "margin-md-left"
                        )}
                        {this.renderRadioCheckboxWithLabel(
                            "Section9_OtherDuringPregnancy_Other",
                            "OthersLabel",
                            model.Other.Value,
                            value => {
                                this.mutateOtherDuringPregnancyModel(
                                    s => s.Section9.Other.Other.Value = value,
                                    true,
                                    () => this.setFocusTextbox(value, this.substanceUseOtherDuringPregnancy)
                                );
                            },
                            this.getAdditionalTextBox({
                                id: this.substanceUseOtherDuringPregnancy,
                                value: model.Other.Description,
                                onChange: value => this.mutateOtherDuringPregnancyModel(s => s.Section9.Other.Other.setDescriptionAndCheckbox(value)),
                                maxLength: this.page1FieldLimits.SubstanceUse_OthersDuringPregnancy_OthersDescription.MaxChars,
                                valueClassName: "margin-xs-left"
                            }),
                            true,
                            "margin-md-left"
                        )}
                    </div>
                </div>
            </div>
        );
    }

    private mutateOtherDuringPregnancyModel(mutation: (state: BritishColumbiaObstetricalFileForm) => void, updateForm?: boolean, then?: () => void): void {
        this.props.mutateModelState(
            s => {
                mutation(s);
                s.Section9.Other.HasOtherDuringPregnancy ??= s.Section9.Other.hasSelectedAnyOtherSubstanceUse();
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();

                then?.();
            }
        );
    }
}

export { BritishColumbiaObstetricalFileOtherDuringPregnancySubSection };
